export const BNP_WORKFLOWS_ADMIN_PRIVILEGE = "BNP_WORKFLOWS_ADMIN_PRIVILEGE";
export const BNP_WORKFLOW_APPROVER_PRIVILEGE = "BNP_WORKFLOW_APPROVER_PRIVILEGE";
export const BNP_FORM_SUBMISSION_PRIVILEGE = "BNP_FORM_SUBMISSION_PRIVILEGE";
export const BNP_MILESTONE_ADMIN_PRIVILEGE = "BNP_MILESTONE_ADMIN_PRIVILEGE";
export const BNP_TASK_ASSIGNEE_ONLY_PRIVILEGE = "BNP_TASK_ASSIGNEE_ONLY_PRIVILEGE";
